var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPyramid3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "16 15.5 68 59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-0"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 4,
      fill: "rgb(255, 255, 255)"
    },
    cx: 51.482,
    cy: 51.458,
    rx: 17,
    ry: 7.65,
    transform: "matrix(1, 0, -0.009007, 1, -0.08461, -0.408365)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 71.948 -5.864 L 101.948 46.097 L 41.948 46.097 L 71.948 -5.864 Z",
    style: {
      strokeWidth: 4,
      fill: "rgb(255, 255, 255)"
    },
    transform: "matrix(1, 0.000035, 0.008972, 1, -20.679853, 26.381643)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 71.948 -5.864 L 101.948 46.097 L 41.948 46.097 L 71.948 -5.864 Z",
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(36, 111, 241)",
      strokeWidth: 4
    },
    transform: "matrix(1, 0.000035, -0.000035, 1, -21.946388, 25.862532)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(216, 216, 216)"
    },
    cx: 47.666,
    cy: 48.954,
    r: 3.728
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(36, 111, 241)"
    },
    cx: 50.455,
    cy: 50.911,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 4,
      stroke: "rgb(36, 111, 241)",
      mask: "url(#mask-0)",
      fill: "none"
    },
    cx: 50.3,
    cy: 50.939,
    r: 8.539
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 4,
      stroke: "rgb(36, 111, 241)",
      fill: "none",
      mask: "url(#mask-1)"
    },
    cx: 51.482,
    cy: 51.458,
    rx: 18.976,
    ry: 8.539,
    transform: "matrix(1, 0, -0.009007, 1, -1.028915, -0.519111)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(216, 216, 216)"
    },
    cx: 53.233,
    cy: 48.133,
    r: 1.907
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyramid3);
export default __webpack_public_path__ + "static/media/pyramid3.55522c09c66fc9759705f2a4b995d39a.svg";
export { ForwardRef as ReactComponent };